import { render, staticRenderFns } from "./checkout-cart-addons.vue?vue&type=template&id=446c6084&scoped=true"
import script from "./checkout-cart-addons.vue?vue&type=script&lang=js"
export * from "./checkout-cart-addons.vue?vue&type=script&lang=js"
import style0 from "./checkout-cart-addons.vue?vue&type=style&index=0&id=446c6084&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446c6084",
  null
  
)

export default component.exports